'use strict';

define('ali_nc', [], function () {
    var isMobile = /(nokia|iphone|android|ipad|motorola|htc|huawei|novarra|CoolPad|blackberry|samsung|symbian|smartphone|wap|phone|windows ce|iemobile|opera\s*mobi|opera\*mini|320x320|240x320|176x220)/i.test(
        navigator.userAgent
    );
    var loaded = false;
    var initTasks = [];
    var initNc = function (opt) {
        var innerNc;
        if (isMobile) {
            innerNc = window.NoCaptcha.init(opt);
            window.NoCaptcha.setEnabled(true);
            innerNc.reset();
        } else {
            innerNc = new window.noCaptcha(opt);
        }
        return {
            reset: function () {
                // eslint-disable-next-line no-unused-expressions
                isMobile ? innerNc.reset() : innerNc.reload();
            },
            hide: function () {
                innerNc.hide();
            },
            show: function () {
                innerNc.show();
            },
            setTrans: function (obj) {
                innerNc.setTrans(obj);
            },
            upLang: function (str, obj) {
                isMobile
                    ? window.NoCaptcha.upLang(str, obj)
                    : innerNc.upLang(str, obj);
            },
            isMobile: isMobile,
            _nc: innerNc,
        };
    };

    var script = document.createElement('script');
    script.charset = 'utf-8';
    script.onload = function () {
        loaded = true;
        initTasks.forEach(function (task) {
            var exportNc = initNc(task.opt);
            // eslint-disable-next-line no-unused-expressions
            task.cb && task.cb(exportNc);
        });
        initTasks = [];
    };

    if (isMobile) {
        script.src = '//g.alicdn.com/sd/nch5/index.js?t=2015052012';
    } else {
        script.src = '//g.alicdn.com/sd/ncpc/nc.js?t=2015052012';
    }
    document.body.appendChild(script);
    script = null;

    return {
        init: function (opt, cb) {
            if (loaded) {
                var exportNc = initNc(opt);
                // eslint-disable-next-line no-unused-expressions
                cb && cb(exportNc);
            } else {
                initTasks.push({
                    opt: opt,
                    cb: cb,
                });
            }
        },
    };
});
